import ProgressBar from "../../components/dashboard/ProgressBar";
import { useState, useEffect } from "react";
import axios from "axios";

/** Display names for disability types (must match backend keys). */
const DISABILITY_TYPES_DATA = [
  { name: "None", key: "none" },
  { name: "Mobility", key: "mobility" },
  { name: "Visual", key: "visual" },
  { name: "Hearing", key: "hearing" },
  { name: "Cognitive", key: "cognitive" },
  { name: "Psychological", key: "psychological" },
  { name: "Other", key: "other" },
];

const baseUrl =
  process.env.REACT_APP_PUBLIC_API_URL
  
  
const DisabilityTypes = () => {
  const [disabilityTypes, setDisabilityTypes] = useState(null);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    axios
      .get(`${baseUrl}/disability-types`)
      .then((response) => {
        const data = response.data;
        if (data.success && data.disabilityTypes) {
          setDisabilityTypes(data.disabilityTypes);
          setTotal(data.disabilityTypes.total ?? 0);
        }
      })
      .catch((error) => console.error("Error fetching disability types:", error));
  }, []);

  const list = disabilityTypes
    ? DISABILITY_TYPES_DATA.map(({ name, key }) => {
        const count = Number(disabilityTypes[key] ?? 0);
        const percent =
          total > 0 ? Math.round((count / total) * 1000) / 10 : 0;
        return { name, count, percent };
      })
    : [];

  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm">
      <h2 className="text-lg font-semibold mb-6">Disability Types</h2>

      {list.length === 0 && disabilityTypes === null ? (
        <p className="text-sm text-gray-500">Loading...</p>
      ) : (
        <div className="space-y-4">
          {list.map((item) => (
            <div key={item.name}>
              <div className="flex justify-between text-sm mb-1">
                <span>{item.name}</span>
                <span className="text-green-700 font-semibold">
                  {item.count.toLocaleString()} ({item.percent}%)
                </span>
              </div>
              <ProgressBar value={item.percent} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DisabilityTypes;
